import React from 'react';
import { LinkList } from '../ui/link-list/LinkList';
import { PrenavLink } from '../prenav-link/PrenavLink';

import styles from './top-links.scss';

export const TopLinks = ({ links }) => (
  <LinkList links={links} Item={PrenavLink} className={styles.links} />
);
